import React, { useEffect, useRef } from "react";
import { AdProps } from "../types";
import useGpt from "../../hooks/Ads/GPT";
import { useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import { selectLoading } from "../../redux/slices/playerSlice";
import {selectConsent} from "../../redux/slices/adsSlice";

let adCounter = 0;

const GptAd = ({ path }: AdProps) => {
  const GPTAdsManager = useGpt();
  const consentValue = useSelector(selectConsent);
  const loading = useSelector(selectLoading);
  const adContainerRef = useRef<HTMLDivElement>(null);

  // const path = "/72835659/test_responsive_adunit"
  const id = React.useMemo(() => `div-gpt-ad-${++adCounter}`, []);

  useEffect(() => {
    // Wait for DOM to be ready
    if (GPTAdsManager && GPTAdsManager.createSlot && !loading) {
      // Create a small delay to ensure the container has rendered
      const timer = setTimeout(() => {
        const slot = GPTAdsManager.createSlot(path, id);

        if (slot) {
          window.googletag.cmd.push(() => {
            window.googletag.display(id);
          });
        }

        return () => {
          if (slot) {
            window.googletag.cmd.push(() => {
              window.googletag.destroySlots([slot]);
            });
          }
        };
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [GPTAdsManager, id, loading, path]);

  return <Box id={id} ref={adContainerRef} />;
};

export default GptAd;